enum Features {
  SaaS = 'saas',
}

export default Features;
